export default function toggle (id) {
  const element = document.getElementById(id);
  if (element.style.display === "none") {
      element.style.display = "block";
    } else { element.style.display = "none"; }
}